// extracted by mini-css-extract-plugin
export default {"topBanner":"TopBanner_topBanner__VO3Z8"};